/* Until Tomorrow theme — minimal vanilla JS */

(function () {
  'use strict';

  /* mobile menu toggle */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* product gallery: one slide at a time, arrows / thumbs / keys / swipe */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    if (slides.length < 2) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var counter = gallery.querySelector('[data-gallery-current]');
    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (counter) counter.textContent = index + 1;
    }

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.getAttribute('data-gallery-thumb'), 10));
      });
    });

    /* arrow keys when the gallery has focus within */
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    /* horizontal swipe on touch devices */
    var startX = null;
    var startY = null;

    gallery.addEventListener('touchstart', function (event) {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      /* ignore mostly-vertical drags so page scrolling still works */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? index + 1 : index - 1);
      }
      startX = null;
      startY = null;
    }, { passive: true });
  });

  /* product form: variant selection via option pills */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = wrapper.querySelector('[data-variant-id]');
    var priceEl = wrapper.querySelector('[data-price]');
    var button = wrapper.querySelector('[data-add-button]');
    var buttonText = wrapper.querySelector('[data-add-button-text]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var format = wrapper.getAttribute('data-money-format') || '${{amount}}';
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function selectedOptions() {
      var values = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) values[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return values;
    }

    function update() {
      var options = selectedOptions();
      var match = product.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });

      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (button) {
          button.disabled = !match.available;
          if (buttonText) buttonText.textContent = match.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold-out');
        }
      } else if (button) {
        button.disabled = true;
        if (buttonText) buttonText.textContent = button.getAttribute('data-label-unavailable');
      }
    }

    wrapper.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  });
})();
